export enum WallConsts {
  INITIAL_WIDTH = 6500,
  INITIAL_HEIGHT = 3000,
  INITIAL_SOCKEL = 150,
  WIDTH_MIN = 3000,
  WIDTH_MAX = 10000,
}
